import React, { useState, createContext, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.scss";
import { Dashboard } from "./modules/Dashboard";
import { Portal } from "./screens/portal";
import { Login } from "./screens/login";
import { Rebalance } from "./modules/Rebalance";
import { TaskList, CreateTask } from "./modules/Task";
import { ForgotPassword } from "./modules/ForgotPassword/ForgotPassword";
import { ResetPassword } from "./modules/ForgotPassword/ResetPassword";
import { ChangePassword } from "./modules/ForgotPassword/ChangePassword";
import { UsersList } from "./modules/Users";
import { QueryClientProvider, QueryClient } from "react-query";
import { Reports } from "./modules/Reports/Reports_View";
import { ReportsDetails } from "./modules/Reports/Reports_Details";
import { TransactionsList } from "./modules/Transactions/TransactionsList";
import { Statements } from "./modules/Statements/Statements";
import { FundPerformance } from "./modules/FundPerformance";
import { AddParticipant } from "./modules/ParticipantAndFund/AddParticipant";
import { AddFund } from "./modules/ParticipantAndFund/AddFund";
import { SearchInvest, PrivacyPolicy, Faq } from "./modules/Content";
import { ClientSelection } from "./modules/ClientSelection";
import { Allocations } from "./modules/Allocations/AllocationsList";
import { UnauthorizedPage } from "./modules/UnauthorizedPage";
import Cookies from "js-cookie";
import { RouteHandler } from "./modules/RouteHandler";
import { FeeSchedules } from "./modules/FeeSchedules"

export const store = createContext();

function App() {
  const [token, setToken] = useState(null);
  const [userId, setUserId] = useState(null);
  const queryClient = new QueryClient();
  const selectedClient = Cookies.get("client");

  return (
    <div className="App theme-blue">
      <QueryClientProvider client={queryClient}>
        <store.Provider value={[token, setToken, userId, setUserId]}>
          <Routes>
            <Route path="/" element={<Login />}></Route>
            <Route path="/forgotpassword" element={<ForgotPassword />}></Route>
            <Route path="/reset-password" element={<ResetPassword />}></Route>
            <Route path="selectclient" element={<ClientSelection />}></Route>
            <Route path="*" element={<UnauthorizedPage />} />
            <Route path="portal" element={<Portal />}>
              <Route
                path="dashboard"
                element={
                  <RouteHandler>
                    <Dashboard />
                  </RouteHandler>
                }
              ></Route>
              <Route
                path="task"
                element={
                  <RouteHandler>
                    <TaskList />
                  </RouteHandler>
                }
              ></Route>
              <Route
                path="reports"
                element={
                  <RouteHandler>
                    <Reports />
                  </RouteHandler>
                }
              ></Route>
              <Route
                path="reports/:reportId"
                element={
                  <RouteHandler>
                    <ReportsDetails />
                  </RouteHandler>
                }
              ></Route>
              <Route
                path="createtask"
                element={
                  <RouteHandler>
                    <CreateTask />
                  </RouteHandler>
                }
              ></Route>
              <Route
                path="users"
                element={
                  <RouteHandler>
                    <UsersList />
                  </RouteHandler>
                }
              ></Route>
              <Route
                path="transactions"
                element={
                  <RouteHandler>
                    <TransactionsList />
                  </RouteHandler>
                }
              ></Route>
              <Route
                path="allocations"
                element={
                  <RouteHandler>
                    <Allocations />
                  </RouteHandler>
                }
              ></Route>
              <Route
                path="Rebalances"
                element={
                  <RouteHandler>
                    <Rebalance />
                  </RouteHandler>
                }
              ></Route>
              <Route
                path="statements"
                element={
                  <RouteHandler>
                    <Statements />
                  </RouteHandler>
                }
              ></Route>
              <Route
                path="fundperformance"
                element={
                  <RouteHandler>
                    <FundPerformance />
                  </RouteHandler>
                }
              ></Route>
              <Route
                path="fund"
                element={
                  <RouteHandler>
                    <AddFund />
                  </RouteHandler>
                }
              ></Route>
              <Route
                path="participant"
                element={
                  <RouteHandler>
                    <AddParticipant />
                  </RouteHandler>
                }
              ></Route>

              <Route path="searchinvest" element={<SearchInvest />}></Route>
              <Route path="privacypolicy" element={<PrivacyPolicy />}></Route>
              <Route path="faqs" element={<RouteHandler><Faq /></RouteHandler>}></Route>
              <Route path="changePassword" element={<ChangePassword />}></Route>
              <Route path="feeschedules" element={<FeeSchedules />}></Route>
            </Route>
          </Routes>
        </store.Provider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
